export default __webpack_public_path__ + "static/media/c04a55ee363b7f83d46d5243b537447b.png";